import React, { useEffect, useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import brLocale from "date-fns/locale/pt-BR";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Button, Stack, TextField, Box } from "@mui/material";
import api from "../../services/api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import "./button.css";
import { makeStyles, useTheme } from "@material-ui/core/styles"; // Importando useTheme
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  chartContent: {
    padding: theme.spacing(2),
  },
}));


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      text: "Atenciones",
      position: "left",
    },
    datalabels: {
      display: true,
      anchor: "start",
      offset: -30,
      align: "start",
      color: "#fff",
      textStrokeColor: "#000",
      textStrokeWidth: 2,
      font: {
        size: 20,
        weight: "bold",
      },
    },
  },
};

export const ChartsDate = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [initialDate, setInitialDate] = useState(new Date());
  const [finalDate, setFinalDate] = useState(new Date());
  const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
  const { user } = useContext(AuthContext);

  useEffect(() => {
    handleGetTicketsInformation();
  }, []);

  const dataCharts = {
    labels:
      ticketsData &&
      ticketsData?.data.length > 0 &&
      ticketsData?.data.map((item) =>
        item.hasOwnProperty("horario")
          ? `Das ${item.horario}:00 as ${item.horario}:59`
          : item.data
      ),
    datasets: [
      {
        data:
          ticketsData?.data.length > 0 &&
          ticketsData?.data.map((item) => item.total),
        backgroundColor: theme.palette.primary.main,
      },
    ],
  };

  const handleGetTicketsInformation = async () => {
    try {
      const { data } = await api.get(
        `/dashboard/ticketsDay?initialDate=${format(
          initialDate,
          "yyyy-MM-dd"
        )}&finalDate=${format(finalDate, "yyyy-MM-dd")}&companyId=${user.companyId}`
      );
      setTicketsData(data);
    } catch (error) {
      toast.error("Error al buscar información de los tickets");
    }
  };

  return (
    <Box className={classes.chartContent}>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
          <DatePicker
            value={initialDate}
            onChange={(newValue) => {
              setInitialDate(newValue);
            }}
            label={i18n.t("dashboard.title.startDate")}
            renderInput={(params) => (
              <TextField size="small" {...params} sx={{ width: "150px" }} />
            )}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
          <DatePicker
            value={finalDate}
            onChange={(newValue) => {
              setFinalDate(newValue);
            }}
            label={i18n.t("dashboard.title.endDate")}
            renderInput={(params) => (
              <TextField size="small" {...params} sx={{ width: "150px" }} />
            )}
          />
        </LocalizationProvider>

        <Button
          className="buttonHover"
          onClick={handleGetTicketsInformation}
          variant="contained"
          size="small"
        >
          {i18n.t("dashboard.title.filter")}
        </Button>
      </Stack>

      <Bar
        options={options}
        data={dataCharts}
        style={{ maxWidth: "100%", height: "280px" }}
      />
    </Box>
  );
};
